import { useQueryData } from "@src/hooks/useQueryData";
import { stockOrdersServices, type StockOrderExtends } from "../../../../../api/stockOrders";

/** Связи заголовка ПО, нужные карточке размещения ТМЦ. */
export const STOCK_PLACEMENT_CARD_INCLUDES = {
    include: ["Division", "SupplyDivision", "SupplyEnterprise", "State", "SupplyDocs"] satisfies Array<
        keyof StockOrderExtends
    >,
} as const;

/** Загружает карточку приходного ордера для размещения ТМЦ. */
export function useStockPlacementCardQuery(orderCode: number) {
    return useQueryData({
        queryKey: ["stock", "placement", orderCode, "card"],
        queryFn: async ({ signal }) => {
            const order = await stockOrdersServices.loadByCode(
                {
                    flt: { StockOrderCode: orderCode },
                    ...STOCK_PLACEMENT_CARD_INCLUDES,
                },
                { signal },
            );

            if (order == null) {
                throw new Error("Ошибка в получении данных приходного ордера");
            }

            return order;
        },
        enabled: orderCode > 0,
        meta: { errorSource: "stock.placement.card" },
    });
}
